import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import {
    Box,
    Button,
    TextField,
    Grid,
    CircularProgress
} from '@material-ui/core'
import {
    CustomSnackBar,
    BaseEditor
} from '../components'
import axios from '../plugins/axios'

const styles = theme => ({
    marginBottom: {
        margin: '0 0 20px 0'
    }
})
class CategoryForm extends Component {

    static defaultProps = {
        name: '',
        body: '',
    }

    constructor(props) {
        super(props)

        const {
            name,
            body,
        } = props

        this.state = {
            fetching: false,
            disabled: false,
            isSnackOpen: false,
            errors: {},
            name,
            body,
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }

    reset = () => {
        this.setState({
            errors: {},
            name: '',
            body: '',
        })
    }

    storeOrUpdate = async e => {
        e.preventDefault()
        this.setState({
            errors: {},
            disabled: true
        })

        const {
            path,
            method
        } = this.props

        const {
            name,
            body,
        } = this.state

        try {
            await axios[method](path, {
                name,
                body,
            })

            this.setState({
                isSnackOpen: true
            })

            if (method === 'post') {
                this.reset()
            }

            this.setState({
                disabled: false
            })
        } catch (err) {
            if (err.response.status === 422) {
                const { errors } = err.response.data
                this.setState({ errors })
            }
        }
    }

    snackClose = () => {
        this.setState({
            isSnackOpen: false
        })
    }

    editorChange = name => e => {
        this.setState({
            [name]: e.target.getContent()
        })
    }

    render() {
        const {
            name,
            body,
            errors,
            isSnackOpen,
            disabled
        } = this.state
        const { message } = this.props
        const { marginBottom } = this.props.classes

        return (
            <div>
                <form
                    onSubmit={this.storeOrUpdate}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.name}
                                helperText={errors.name}
                                label="Нэр"
                                value={name}
                                onChange={this.handleChange('name')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <div className={marginBottom}>
                                <BaseEditor
                                    value={body}
                                    onChange={this.editorChange('body')}
                                />
                            </div>
                            <Box my={3}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    disabled={disabled}
                                >
                                    {
                                        disabled ? <CircularProgress size={25} color="primary" /> : "Хадгалах"
                                    }
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <CustomSnackBar
                        message={message}
                        open={isSnackOpen}
                        snackClose={this.snackClose}
                    />
                </form>
            </div>
        )
    }
}

export default withStyles(styles)(CategoryForm)
